<div class="ds-card">
  <div class="ds-card__cabecera">
    <span class="ds-card__titulo">{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_CONTRATOS' | translate }}</span>
    <div class="col-10 ds-buscador">
      <span class="p-input-icon-left">
        <img src="assets/icons/ico-buscar-lupa.svg" alt="">
        <input type="text" pInputText placeholder="{{ 'LBL_BUSCAR' | translate }}" [(ngModel)]="filtroContratos">
      </span>
    </div>
  </div>
  <p-table [value]="contratosFiltrados" [loading]="cargandoContratos" [paginator]="true" [rows]="10"
           [alwaysShowPaginator]="true" styleClass="ds-tabla">
    <ng-template pTemplate="header">
      <tr>
        <th>{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_CONTRATO' | translate }}</th>
        <th>{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_FECHAFIRMA' | translate }}</th>
        <th class="text-center">{{ 'LBL_ACCIONES' | translate }}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-c>
      <tr>
        <td>{{ c.nombrePlantilla || '--' }}</td>
        <td>{{ c.fechaFirma ? (c.fechaFirma | date:'yyyy-MM-dd') : '--' }}</td>
        <td class="text-center">
          <button type="button" pButton class="btn-action-premium" icon="fa fa-eye"
                  title="{{ 'BTN_VISUALIZAR' | translate }}" (click)="previsualizarContrato(c)">
          </button>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="3" class="text-center">{{ 'MSG_NOHAYREGISTROS' | translate }}</td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-dialog [(visible)]="mostrarModalContrato" [modal]="true" [closable]="true" [draggable]="false"
          [style]="{width: '600px'}" styleClass="ds-dialog" class="footer-center"
          header="{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_CONTRATO' | translate | uppercase }}">
  <div class="admsb-contrato-preview" [innerHTML]="contenidoContrato"></div>
  <ng-template pTemplate="footer">
    <button type="button" pButton class="btn-primary-full" icon="fa fa-close"
            label="{{ 'BTN_CERRAR' | translate }}" (click)="cerrarModalContrato()"></button>
  </ng-template>
</p-dialog>
